import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  // userData: {},
  userAuth: {},
  loggedIn: undefined, // ACHTUNG: muss undefined sein
  // userList: [],
  // sidebarOpen: true,
  initialized: false
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
